import { ReceiptEmail } from '../types/conf';

export const receiptEmails: ReceiptEmail[] = [
    {
        id: 'private-casualty',
        highwayId: '',
        division: 'private',
        section: 'casualty',
        email: {
            from: 'ulykkeskade@topdanmark.dk',
            subject: 'Privat: Ulykke',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-medical-preassessment',
        highwayId: '',
        division: 'private',
        section: 'casualty',
        email: {
            from: 'rejseklar@topdanmark.dk',
            subject: 'Tak for din ansøgning',
            body: 'Tak for din ansøgning om medicinsk forhåndsvurdering. Du kan forvente at høre fra os inden for {response.time}.',
            header: 'Tak for din ansøgning'
        }
    },
    {
        id: 'private-auto',
        highwayId: '',
        division: 'private',
        section: 'auto',
        email: {
            from: 'autoskade@topdanmark.dk',
            subject: 'Privat: Auto',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-auto-default',
        highwayId: '',
        division: 'private',
        section: 'auto',
        email: {
            from: 'autoskade@topdanmark.dk',
            subject: 'Privat: Auto',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-travel',
        highwayId: '',
        division: 'private',
        section: 'XXXXXXX',
        email: {
            from: 'rejse@topdanmark.dk',
            subject: 'Privat: Rejse',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-liability-stuff',
        highwayId: '4fbd73a3-1e16-4ef7-9849-e94d871d78a7',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'ansvarsskade@topdanmark.dk',
            subject: 'Privat: Privatansvar Ting',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'business-travel',
        highwayId: 'd7322411-de35-41eb-b0a4-008d480abae4',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'rejse@topdanmark.dk',
            subject: 'Erhverv: Rejse',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'business-work-injuries',
        highwayId: '4e44d838-eb60-4f6b-9e3b-11761fe799b9',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'arbejdsskade@topdanmark.dk',
            subject: 'Erhverv+Landbrug: Arbejdsskade',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'business-liability',
        highwayId: '78a50660-265f-4967-97a0-929496700495',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'ansvar-erhverv@topdanmark.dk',
            subject: 'Erhverv: Erhvervs- og produktansvar Ting',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-content',
        highwayId: '2b94f85b-746a-40eb-ae6a-656cf213d9a4',
        division: 'private',
        section: 'XXXXXXX',
        email: {
            from: 'tingskade@topdanmark.dk',
            subject: 'Privat: Privatskade  (ting+løsøre) ',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-on-my-house-and-content',
        highwayId: '',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'tingskade@topdanmark.dk',
            subject: 'Privat: Vand/Skybrud Løsøre',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-animals',
        highwayId: '27a926e8-c07f-4701-ac40-42992c420d77',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'dyreforsikring@topdanmark.dk',
            subject: 'Privat: Dyreforsikringer',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'agriculture-auto',
        highwayId: '8eb75009-4964-4db7-8db8-946d2a2105de',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'autoskade@topdanmark.dk',
            subject: 'Landbrug: Auto',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-liability-building',
        highwayId: '',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'ansvarsskade@topdanmark.dk',
            subject: 'Privat: Privatansvar Bygning',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-boat',
        highwayId: '859cdb83-19cb-4bbb-9497-8e817f0593bb',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'baad@topdanmark.dk',
            subject: 'Privat: Båd',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-retshjaelp-over-100000',
        highwayId: '11db1545-18ee-4960-b420-461ff9407498',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'retshjaelp@topdanmark.dk',
            subject: 'Retshjaelp - to solicitor',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'd88fd459-43df-4079-b7c8-e24ca9b4d14d',
        highwayId: 'd88fd459-43df-4079-b7c8-e24ca9b4d14d',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'tingskade@topdanmark.dk',
            subject: 'Privat: Elektronik',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: '8999bed1-b779-49ad-9669-c0aa4a220375',
        highwayId: '8999bed1-b779-49ad-9669-c0aa4a220375',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'personskadeauto@topdanmark.dk',
            subject: 'Erhverv: Personskade auto',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'business-building',
        highwayId: '08b2ea55-81c6-4a22-9745-2d72384d705d',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'erhvervbyg@topdanmark.dk',
            subject: 'Erhverv: Erhvervsskade (bygning)',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: '75818711-cee2-4271-abce-113ff2ea995c',
        highwayId: '75818711-cee2-4271-abce-113ff2ea995c',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'loensikring@topdanmark.dk',
            subject: 'Lønsikring',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'agriculture-building',
        highwayId: 'ef6b0359-dc29-44eb-9083-d0ed6fe13768',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'landbrugbyg@topdanmark.dk',
            subject: 'Landbrug: Landbrugsskade (bygning)',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-retshjaelp-under-100000',
        highwayId: '943efbe9-9405-4520-ac66-057aa906ae98',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'retshjaelp@topdanmark.dk',
            subject: 'Retshjaelp - to customer',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-liability-person',
        highwayId: '',
        division: 'private',
        section: 'injury',
        email: {
            from: 'ansvar-person@topdanmark.dk',
            subject: 'Privat: Personskade ansvar',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'business-liability-person',
        highwayId: '',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'ansvar-person@topdanmark.dk',
            subject: 'Erhverv: Personskade ansvar',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'ddd88c9d-7edc-4946-8dd5-97665b3084e5',
        highwayId: 'ddd88c9d-7edc-4946-8dd5-97665b3084e5',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'baad@topdanmark.dk',
            subject: 'Landbrug: Båd',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: '27906230-e098-4dfd-8c21-daecf89bb984',
        highwayId: '27906230-e098-4dfd-8c21-daecf89bb984',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'personskadeauto@topdanmark.dk',
            subject: 'Privat: Personskade auto',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: '9e25ae97-b408-44e4-ab46-ae93ae09dc78',
        highwayId: '9e25ae97-b408-44e4-ab46-ae93ae09dc78',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'ulykkeskade@topdanmark.dk',
            subject: 'Erhverv: Ulykke',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'agriculture-damage',
        highwayId: '3b949c3f-13bf-4181-a50e-c879f1eacf47',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'tingskade@topdanmark.dk',
            subject: 'Landbrug: Landbrugsskade (ting+løsøre) ',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'agriculture-animals',
        highwayId: '9128f2a8-e81f-4951-ace9-2ff92280ce14',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'dyreforsikring@topdanmark.dk',
            subject: 'Landbrug: Dyreforsikringer',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-water-cloudburst-combi',
        highwayId: '28b4a2b6-06b1-49dc-889a-c1de8a2fe320',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'privatskadebyg@topdanmark.dk',
            subject: 'Privat: Vand/Skybrud Kombi',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: '2b7d8c39-e528-46b9-aea6-50681f2f25e8',
        highwayId: '2b7d8c39-e528-46b9-aea6-50681f2f25e8',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'ansvar-landbrug@topdanmark.dk',
            subject: 'Landbrug: Ansvar Ting',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        highwayId: '60785243-d132-4aba-932e-14a2c900adfa',
        id: 'private-building',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'privatskadebyg@topdanmark.dk',
            subject: 'Privat: Privatskade (bygning)',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'erhverv-auto',
        highwayId: '41c918bc-eeef-4af2-b09f-1f99a5ae241d',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'autoskade@topdanmark.dk',
            subject: 'Erhverv: Auto',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        highwayId: '485dc15a-cf6f-4a73-939e-29b76f534bf6',
        id: 'private-casualty',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'ulykkeskade@topdanmark.dk',
            subject: 'Privat: Ulykke',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-bicycle',
        highwayId: '93169ef3-6d8a-43ae-8297-aab841ff5b52',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'tingskade@topdanmark.dk',
            subject: 'Privat: Cykel',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'ce546382-550e-4ea6-8cab-75492b0b0055',
        highwayId: 'ce546382-550e-4ea6-8cab-75492b0b0055',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'personskadeauto@topdanmark.dk',
            subject: 'Landbrug: Personskade auto',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'agriculture-casualty',
        highwayId: '797fc85c-c4cb-4623-9518-b776edd9d3a1',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'ulykkeskade@topdanmark.dk',
            subject: 'Landbrug: Ulykke',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: '94cc0c6a-4d18-43ee-9e7c-a84f0935617b',
        highwayId: '94cc0c6a-4d18-43ee-9e7c-a84f0935617b',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'hjaelp@coopforsikringer.dk',
            subject: 'Dødsfald',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: '70410776-dc81-4658-81ff-a2ef84aa6bef',
        highwayId: '70410776-dc81-4658-81ff-a2ef84aa6bef',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'rejse@topdanmark.dk',
            subject: 'Landbrug: Rejse',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'cd98432e-0386-444a-b982-22f0ae1564ee',
        highwayId: 'cd98432e-0386-444a-b982-22f0ae1564ee',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'sundhedscenter@topdanmark.dk',
            subject: 'Sundhedssikring',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        highwayId: '54b0401c-e89b-4337-b6d0-5c94b40c2bf2',
        id: 'private-travel',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'rejse@topdanmark.dk',
            subject: 'Privat: Rejse',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-liability-animal',
        highwayId: '3e30e307-cc66-4d4b-a992-b3764cb99171',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'ansvarsskade@topdanmark.dk',
            subject: 'Privat: Privatansvar dyr',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'business-property-damage',
        highwayId: '08d3858c-0971-411a-8db4-66a0390d4868',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'tingskade@topdanmark.dk',
            subject: 'Erhverv: Erhvervsskade (ting+løsøre) ',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'c473fd0e-8748-484d-b9c1-c4c7a2c4b67e',
        highwayId: 'c473fd0e-8748-484d-b9c1-c4c7a2c4b67e',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'skadesteam@topdanmark.dk',
            subject: 'Tab af erhvervsevne',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: '3cb05926-3f80-4e7f-8887-faedd4b8b4f7',
        highwayId: '3cb05926-3f80-4e7f-8887-faedd4b8b4f7',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'skadesteam@topdanmark.dk',
            subject: 'Kritisk sygdom',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'd2c7f8a0-88c1-4ccd-92a2-0ce79ca7418c',
        highwayId: 'd2c7f8a0-88c1-4ccd-92a2-0ce79ca7418c',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'skadesteam-udbetal@topdanmark.dk',
            subject: 'Dødsfald',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    },
    {
        id: 'private-ownership-change',
        highwayId: 'b4df7d3e-41ee-4361-b32b-419ebef8bf1f',
        division: 'XXXXXXX',
        section: 'XXXXXXX',
        email: {
            from: 'ejerskifte-bygge@topdanmark.dk',
            subject: 'Privat: Ejerskifte',
            body: 'Vi har modtaget din anmeldelse. Vi gennemgår den hurtigst muligt, hvorefter vi kontakter dig - normalt inden for {response.time}.\n\n',
            header: 'Her får du en kvittering på din anmeldelse'
        }
    }
];
